
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBYj9BqYNfAZo_gjMw_bCxKUQeNPogAq5k",
  authDomain: "mynew-ae4f6.firebaseapp.com",
  projectId: "mynew-ae4f6",
  storageBucket: "mynew-ae4f6.appspot.com",
  messagingSenderId: "448023023074",
  appId: "1:448023023074:web:c218e046fcf1c303ff7dbb",
  measurementId: "G-9GQ3HFVST5"
};


const app = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const db = app.firestore();

const googleProvider = new firebase.auth.GoogleAuthProvider();


// Function to add a new user to the database
export { auth, googleProvider };

export default db;